import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ProjectRecap from './ProjectRecap';

const ProjectRecapWrapper = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [finalVideoUrl, setFinalVideoUrl] = useState('');

  useEffect(() => {
    const fetchProject = async () => {
      const res = await fetch(`/projects/${id}/recap`);
      const data = await res.json();
      setProject(data.project);
      setFinalVideoUrl(data.finalVideoUrl);
    };

    fetchProject();
  }, [id]);

  if (!project) return <div className="text-center mt-5">Chargement...</div>;

  return <ProjectRecap project={project} finalVideoUrl={finalVideoUrl} />;
};

export default ProjectRecapWrapper;
